/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as LoginRouteImport } from './routes/login'
import { Route as TreasuryRouteImport } from './routes/treasury'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardAgentsRouteImport } from './routes/dashboard/agents'
import { Route as DashboardAlertsRouteImport } from './routes/dashboard/alerts'
import { Route as DashboardAnnouncementsRouteImport } from './routes/dashboard/announcements'
import { Route as DashboardApiKeysRouteImport } from './routes/dashboard/api-keys'
import { Route as DashboardAuditRouteImport } from './routes/dashboard/audit'
import { Route as DashboardMetaProposalsRouteImport } from './routes/dashboard/meta-proposals'
import { Route as DashboardOperationsRouteImport } from './routes/dashboard/operations'
import { Route as DashboardRolesRouteImport } from './routes/dashboard/roles'
import { Route as DashboardSessionsRouteImport } from './routes/dashboard/sessions'
import { Route as DashboardSettingsRouteImport } from './routes/dashboard/settings'
import { Route as DashboardSystemLogsRouteImport } from './routes/dashboard/system-logs'
import { Route as DashboardTelegramRouteImport } from './routes/dashboard/telegram'
import { Route as DashboardTradersRouteImport } from './routes/dashboard/traders'
import { Route as DashboardTradesRouteImport } from './routes/dashboard/trades'
import { Route as DashboardWalletsRouteImport } from './routes/dashboard/wallets'
import { Route as DashboardContractsDividendsRouteImport } from './routes/dashboard/contracts/dividends'
import { Route as DashboardContractsListsRouteImport } from './routes/dashboard/contracts/lists'
import { Route as DashboardContractsManagerRouteImport } from './routes/dashboard/contracts/manager'
import { Route as DashboardContractsOwnershipRouteImport } from './routes/dashboard/contracts/ownership'
import { Route as DashboardContractsVanityRouteImport } from './routes/dashboard/contracts/vanity'
import { Route as DashboardSupernovaIndexRouteImport } from './routes/dashboard/supernova/index'
import { Route as DashboardSupernovaIdRouteImport } from './routes/dashboard/supernova/$id'
import { Route as DashboardTokensIndexRouteImport } from './routes/dashboard/tokens/index'
import { Route as DashboardTokensAddressRouteImport } from './routes/dashboard/tokens/$address'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const TreasuryRoute = TreasuryRouteImport.update({
  id: '/treasury',
  path: '/treasury',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAgentsRoute = DashboardAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAlertsRoute = DashboardAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAnnouncementsRoute = DashboardAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardApiKeysRoute = DashboardApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAuditRoute = DashboardAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardMetaProposalsRoute = DashboardMetaProposalsRouteImport.update({
  id: '/meta-proposals',
  path: '/meta-proposals',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardOperationsRoute = DashboardOperationsRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardRolesRoute = DashboardRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSessionsRoute = DashboardSessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSystemLogsRoute = DashboardSystemLogsRouteImport.update({
  id: '/system-logs',
  path: '/system-logs',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTelegramRoute = DashboardTelegramRouteImport.update({
  id: '/telegram',
  path: '/telegram',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTradersRoute = DashboardTradersRouteImport.update({
  id: '/traders',
  path: '/traders',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTradesRoute = DashboardTradesRouteImport.update({
  id: '/trades',
  path: '/trades',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardWalletsRoute = DashboardWalletsRouteImport.update({
  id: '/wallets',
  path: '/wallets',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardContractsDividendsRoute =
  DashboardContractsDividendsRouteImport.update({
    id: '/contracts/dividends',
    path: '/contracts/dividends',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardContractsListsRoute = DashboardContractsListsRouteImport.update({
  id: '/contracts/lists',
  path: '/contracts/lists',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardContractsManagerRoute =
  DashboardContractsManagerRouteImport.update({
    id: '/contracts/manager',
    path: '/contracts/manager',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardContractsOwnershipRoute =
  DashboardContractsOwnershipRouteImport.update({
    id: '/contracts/ownership',
    path: '/contracts/ownership',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardContractsVanityRoute =
  DashboardContractsVanityRouteImport.update({
    id: '/contracts/vanity',
    path: '/contracts/vanity',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSupernovaIndexRoute = DashboardSupernovaIndexRouteImport.update({
  id: '/supernova/',
  path: '/supernova/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSupernovaIdRoute = DashboardSupernovaIdRouteImport.update({
  id: '/supernova/$id',
  path: '/supernova/$id',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTokensIndexRoute = DashboardTokensIndexRouteImport.update({
  id: '/tokens/',
  path: '/tokens/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTokensAddressRoute = DashboardTokensAddressRouteImport.update({
  id: '/tokens/$address',
  path: '/tokens/$address',
  getParentRoute: () => DashboardRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/login': typeof LoginRoute
  '/treasury': typeof TreasuryRoute
  '/dashboard/agents': typeof DashboardAgentsRoute
  '/dashboard/alerts': typeof DashboardAlertsRoute
  '/dashboard/announcements': typeof DashboardAnnouncementsRoute
  '/dashboard/api-keys': typeof DashboardApiKeysRoute
  '/dashboard/audit': typeof DashboardAuditRoute
  '/dashboard/meta-proposals': typeof DashboardMetaProposalsRoute
  '/dashboard/operations': typeof DashboardOperationsRoute
  '/dashboard/roles': typeof DashboardRolesRoute
  '/dashboard/sessions': typeof DashboardSessionsRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/dashboard/system-logs': typeof DashboardSystemLogsRoute
  '/dashboard/telegram': typeof DashboardTelegramRoute
  '/dashboard/traders': typeof DashboardTradersRoute
  '/dashboard/trades': typeof DashboardTradesRoute
  '/dashboard/wallets': typeof DashboardWalletsRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/contracts/dividends': typeof DashboardContractsDividendsRoute
  '/dashboard/contracts/lists': typeof DashboardContractsListsRoute
  '/dashboard/contracts/manager': typeof DashboardContractsManagerRoute
  '/dashboard/contracts/ownership': typeof DashboardContractsOwnershipRoute
  '/dashboard/contracts/vanity': typeof DashboardContractsVanityRoute
  '/dashboard/supernova/$id': typeof DashboardSupernovaIdRoute
  '/dashboard/tokens/$address': typeof DashboardTokensAddressRoute
  '/dashboard/supernova/': typeof DashboardSupernovaIndexRoute
  '/dashboard/tokens/': typeof DashboardTokensIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/treasury': typeof TreasuryRoute
  '/dashboard/agents': typeof DashboardAgentsRoute
  '/dashboard/alerts': typeof DashboardAlertsRoute
  '/dashboard/announcements': typeof DashboardAnnouncementsRoute
  '/dashboard/api-keys': typeof DashboardApiKeysRoute
  '/dashboard/audit': typeof DashboardAuditRoute
  '/dashboard/meta-proposals': typeof DashboardMetaProposalsRoute
  '/dashboard/operations': typeof DashboardOperationsRoute
  '/dashboard/roles': typeof DashboardRolesRoute
  '/dashboard/sessions': typeof DashboardSessionsRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/dashboard/system-logs': typeof DashboardSystemLogsRoute
  '/dashboard/telegram': typeof DashboardTelegramRoute
  '/dashboard/traders': typeof DashboardTradersRoute
  '/dashboard/trades': typeof DashboardTradesRoute
  '/dashboard/wallets': typeof DashboardWalletsRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/contracts/dividends': typeof DashboardContractsDividendsRoute
  '/dashboard/contracts/lists': typeof DashboardContractsListsRoute
  '/dashboard/contracts/manager': typeof DashboardContractsManagerRoute
  '/dashboard/contracts/ownership': typeof DashboardContractsOwnershipRoute
  '/dashboard/contracts/vanity': typeof DashboardContractsVanityRoute
  '/dashboard/supernova/$id': typeof DashboardSupernovaIdRoute
  '/dashboard/tokens/$address': typeof DashboardTokensAddressRoute
  '/dashboard/supernova': typeof DashboardSupernovaIndexRoute
  '/dashboard/tokens': typeof DashboardTokensIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/login': typeof LoginRoute
  '/treasury': typeof TreasuryRoute
  '/dashboard/agents': typeof DashboardAgentsRoute
  '/dashboard/alerts': typeof DashboardAlertsRoute
  '/dashboard/announcements': typeof DashboardAnnouncementsRoute
  '/dashboard/api-keys': typeof DashboardApiKeysRoute
  '/dashboard/audit': typeof DashboardAuditRoute
  '/dashboard/meta-proposals': typeof DashboardMetaProposalsRoute
  '/dashboard/operations': typeof DashboardOperationsRoute
  '/dashboard/roles': typeof DashboardRolesRoute
  '/dashboard/sessions': typeof DashboardSessionsRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/dashboard/system-logs': typeof DashboardSystemLogsRoute
  '/dashboard/telegram': typeof DashboardTelegramRoute
  '/dashboard/traders': typeof DashboardTradersRoute
  '/dashboard/trades': typeof DashboardTradesRoute
  '/dashboard/wallets': typeof DashboardWalletsRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/contracts/dividends': typeof DashboardContractsDividendsRoute
  '/dashboard/contracts/lists': typeof DashboardContractsListsRoute
  '/dashboard/contracts/manager': typeof DashboardContractsManagerRoute
  '/dashboard/contracts/ownership': typeof DashboardContractsOwnershipRoute
  '/dashboard/contracts/vanity': typeof DashboardContractsVanityRoute
  '/dashboard/supernova/$id': typeof DashboardSupernovaIdRoute
  '/dashboard/tokens/$address': typeof DashboardTokensAddressRoute
  '/dashboard/supernova/': typeof DashboardSupernovaIndexRoute
  '/dashboard/tokens/': typeof DashboardTokensIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/login'
    | '/treasury'
    | '/dashboard/agents'
    | '/dashboard/alerts'
    | '/dashboard/announcements'
    | '/dashboard/api-keys'
    | '/dashboard/audit'
    | '/dashboard/meta-proposals'
    | '/dashboard/operations'
    | '/dashboard/roles'
    | '/dashboard/sessions'
    | '/dashboard/settings'
    | '/dashboard/system-logs'
    | '/dashboard/telegram'
    | '/dashboard/traders'
    | '/dashboard/trades'
    | '/dashboard/wallets'
    | '/dashboard/'
    | '/dashboard/contracts/dividends'
    | '/dashboard/contracts/lists'
    | '/dashboard/contracts/manager'
    | '/dashboard/contracts/ownership'
    | '/dashboard/contracts/vanity'
    | '/dashboard/supernova/$id'
    | '/dashboard/tokens/$address'
    | '/dashboard/supernova/'
    | '/dashboard/tokens/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/treasury'
    | '/dashboard/agents'
    | '/dashboard/alerts'
    | '/dashboard/announcements'
    | '/dashboard/api-keys'
    | '/dashboard/audit'
    | '/dashboard/meta-proposals'
    | '/dashboard/operations'
    | '/dashboard/roles'
    | '/dashboard/sessions'
    | '/dashboard/settings'
    | '/dashboard/system-logs'
    | '/dashboard/telegram'
    | '/dashboard/traders'
    | '/dashboard/trades'
    | '/dashboard/wallets'
    | '/dashboard'
    | '/dashboard/contracts/dividends'
    | '/dashboard/contracts/lists'
    | '/dashboard/contracts/manager'
    | '/dashboard/contracts/ownership'
    | '/dashboard/contracts/vanity'
    | '/dashboard/supernova/$id'
    | '/dashboard/tokens/$address'
    | '/dashboard/supernova'
    | '/dashboard/tokens'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/login'
    | '/treasury'
    | '/dashboard/agents'
    | '/dashboard/alerts'
    | '/dashboard/announcements'
    | '/dashboard/api-keys'
    | '/dashboard/audit'
    | '/dashboard/meta-proposals'
    | '/dashboard/operations'
    | '/dashboard/roles'
    | '/dashboard/sessions'
    | '/dashboard/settings'
    | '/dashboard/system-logs'
    | '/dashboard/telegram'
    | '/dashboard/traders'
    | '/dashboard/trades'
    | '/dashboard/wallets'
    | '/dashboard/'
    | '/dashboard/contracts/dividends'
    | '/dashboard/contracts/lists'
    | '/dashboard/contracts/manager'
    | '/dashboard/contracts/ownership'
    | '/dashboard/contracts/vanity'
    | '/dashboard/supernova/$id'
    | '/dashboard/tokens/$address'
    | '/dashboard/supernova/'
    | '/dashboard/tokens/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  LoginRoute: typeof LoginRoute
  TreasuryRoute: typeof TreasuryRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/treasury': {
      id: '/treasury'
      path: '/treasury'
      fullPath: '/treasury'
      preLoaderRoute: typeof TreasuryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/agents': {
      id: '/dashboard/agents'
      path: '/agents'
      fullPath: '/dashboard/agents'
      preLoaderRoute: typeof DashboardAgentsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/alerts': {
      id: '/dashboard/alerts'
      path: '/alerts'
      fullPath: '/dashboard/alerts'
      preLoaderRoute: typeof DashboardAlertsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/announcements': {
      id: '/dashboard/announcements'
      path: '/announcements'
      fullPath: '/dashboard/announcements'
      preLoaderRoute: typeof DashboardAnnouncementsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/api-keys': {
      id: '/dashboard/api-keys'
      path: '/api-keys'
      fullPath: '/dashboard/api-keys'
      preLoaderRoute: typeof DashboardApiKeysRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/audit': {
      id: '/dashboard/audit'
      path: '/audit'
      fullPath: '/dashboard/audit'
      preLoaderRoute: typeof DashboardAuditRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/meta-proposals': {
      id: '/dashboard/meta-proposals'
      path: '/meta-proposals'
      fullPath: '/dashboard/meta-proposals'
      preLoaderRoute: typeof DashboardMetaProposalsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/operations': {
      id: '/dashboard/operations'
      path: '/operations'
      fullPath: '/dashboard/operations'
      preLoaderRoute: typeof DashboardOperationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/roles': {
      id: '/dashboard/roles'
      path: '/roles'
      fullPath: '/dashboard/roles'
      preLoaderRoute: typeof DashboardRolesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/sessions': {
      id: '/dashboard/sessions'
      path: '/sessions'
      fullPath: '/dashboard/sessions'
      preLoaderRoute: typeof DashboardSessionsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/settings': {
      id: '/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/system-logs': {
      id: '/dashboard/system-logs'
      path: '/system-logs'
      fullPath: '/dashboard/system-logs'
      preLoaderRoute: typeof DashboardSystemLogsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/telegram': {
      id: '/dashboard/telegram'
      path: '/telegram'
      fullPath: '/dashboard/telegram'
      preLoaderRoute: typeof DashboardTelegramRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/traders': {
      id: '/dashboard/traders'
      path: '/traders'
      fullPath: '/dashboard/traders'
      preLoaderRoute: typeof DashboardTradersRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/trades': {
      id: '/dashboard/trades'
      path: '/trades'
      fullPath: '/dashboard/trades'
      preLoaderRoute: typeof DashboardTradesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/wallets': {
      id: '/dashboard/wallets'
      path: '/wallets'
      fullPath: '/dashboard/wallets'
      preLoaderRoute: typeof DashboardWalletsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/contracts/dividends': {
      id: '/dashboard/contracts/dividends'
      path: '/contracts/dividends'
      fullPath: '/dashboard/contracts/dividends'
      preLoaderRoute: typeof DashboardContractsDividendsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/contracts/lists': {
      id: '/dashboard/contracts/lists'
      path: '/contracts/lists'
      fullPath: '/dashboard/contracts/lists'
      preLoaderRoute: typeof DashboardContractsListsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/contracts/manager': {
      id: '/dashboard/contracts/manager'
      path: '/contracts/manager'
      fullPath: '/dashboard/contracts/manager'
      preLoaderRoute: typeof DashboardContractsManagerRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/contracts/ownership': {
      id: '/dashboard/contracts/ownership'
      path: '/contracts/ownership'
      fullPath: '/dashboard/contracts/ownership'
      preLoaderRoute: typeof DashboardContractsOwnershipRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/contracts/vanity': {
      id: '/dashboard/contracts/vanity'
      path: '/contracts/vanity'
      fullPath: '/dashboard/contracts/vanity'
      preLoaderRoute: typeof DashboardContractsVanityRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/supernova/': {
      id: '/dashboard/supernova/'
      path: '/supernova'
      fullPath: '/dashboard/supernova/'
      preLoaderRoute: typeof DashboardSupernovaIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/supernova/$id': {
      id: '/dashboard/supernova/$id'
      path: '/supernova/$id'
      fullPath: '/dashboard/supernova/$id'
      preLoaderRoute: typeof DashboardSupernovaIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/tokens/': {
      id: '/dashboard/tokens/'
      path: '/tokens'
      fullPath: '/dashboard/tokens/'
      preLoaderRoute: typeof DashboardTokensIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/tokens/$address': {
      id: '/dashboard/tokens/$address'
      path: '/tokens/$address'
      fullPath: '/dashboard/tokens/$address'
      preLoaderRoute: typeof DashboardTokensAddressRouteImport
      parentRoute: typeof DashboardRoute
    }
  }
}

interface DashboardRouteChildren {
  DashboardAgentsRoute: typeof DashboardAgentsRoute
  DashboardAlertsRoute: typeof DashboardAlertsRoute
  DashboardAnnouncementsRoute: typeof DashboardAnnouncementsRoute
  DashboardApiKeysRoute: typeof DashboardApiKeysRoute
  DashboardAuditRoute: typeof DashboardAuditRoute
  DashboardMetaProposalsRoute: typeof DashboardMetaProposalsRoute
  DashboardOperationsRoute: typeof DashboardOperationsRoute
  DashboardRolesRoute: typeof DashboardRolesRoute
  DashboardSessionsRoute: typeof DashboardSessionsRoute
  DashboardSettingsRoute: typeof DashboardSettingsRoute
  DashboardSystemLogsRoute: typeof DashboardSystemLogsRoute
  DashboardTelegramRoute: typeof DashboardTelegramRoute
  DashboardTradersRoute: typeof DashboardTradersRoute
  DashboardTradesRoute: typeof DashboardTradesRoute
  DashboardWalletsRoute: typeof DashboardWalletsRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardContractsDividendsRoute: typeof DashboardContractsDividendsRoute
  DashboardContractsListsRoute: typeof DashboardContractsListsRoute
  DashboardContractsManagerRoute: typeof DashboardContractsManagerRoute
  DashboardContractsOwnershipRoute: typeof DashboardContractsOwnershipRoute
  DashboardContractsVanityRoute: typeof DashboardContractsVanityRoute
  DashboardSupernovaIdRoute: typeof DashboardSupernovaIdRoute
  DashboardTokensAddressRoute: typeof DashboardTokensAddressRoute
  DashboardSupernovaIndexRoute: typeof DashboardSupernovaIndexRoute
  DashboardTokensIndexRoute: typeof DashboardTokensIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAgentsRoute: DashboardAgentsRoute,
  DashboardAlertsRoute: DashboardAlertsRoute,
  DashboardAnnouncementsRoute: DashboardAnnouncementsRoute,
  DashboardApiKeysRoute: DashboardApiKeysRoute,
  DashboardAuditRoute: DashboardAuditRoute,
  DashboardMetaProposalsRoute: DashboardMetaProposalsRoute,
  DashboardOperationsRoute: DashboardOperationsRoute,
  DashboardRolesRoute: DashboardRolesRoute,
  DashboardSessionsRoute: DashboardSessionsRoute,
  DashboardSettingsRoute: DashboardSettingsRoute,
  DashboardSystemLogsRoute: DashboardSystemLogsRoute,
  DashboardTelegramRoute: DashboardTelegramRoute,
  DashboardTradersRoute: DashboardTradersRoute,
  DashboardTradesRoute: DashboardTradesRoute,
  DashboardWalletsRoute: DashboardWalletsRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardContractsDividendsRoute: DashboardContractsDividendsRoute,
  DashboardContractsListsRoute: DashboardContractsListsRoute,
  DashboardContractsManagerRoute: DashboardContractsManagerRoute,
  DashboardContractsOwnershipRoute: DashboardContractsOwnershipRoute,
  DashboardContractsVanityRoute: DashboardContractsVanityRoute,
  DashboardSupernovaIdRoute: DashboardSupernovaIdRoute,
  DashboardTokensAddressRoute: DashboardTokensAddressRoute,
  DashboardSupernovaIndexRoute: DashboardSupernovaIndexRoute,
  DashboardTokensIndexRoute: DashboardTokensIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRouteWithChildren,
  LoginRoute: LoginRoute,
  TreasuryRoute: TreasuryRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
